import { type MouseEvent, useEffect, useRef } from 'react'

interface ImageItem {
  id: string
}

interface ImageListSelectionOptions {
  items: ImageItem[]
  selectedImageId: string | undefined
  onImageSelect: (imageId: string) => void
}

// TODO: Remove this adapter when CoreCSS ImageList exposes selected-image state and per-item selection handlers. This was added as a workaround since UploadElement (as of COSMA 10.3 doesn't support)

export const useImageListSelection = ({ items, selectedImageId, onImageSelect }: ImageListSelectionOptions) => {
  const imageListRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const thumbnailElements = Array.from(imageListRef.current?.children ?? [])
      .slice(0, items.length)
      .filter((element): element is HTMLElement => element instanceof HTMLElement)

    thumbnailElements.forEach((thumbnailElement, index) => {
      const item = items[index]
      const imageElement = thumbnailElement.querySelector('img')
      if (!item || !imageElement) return

      const isSelected = item.id === selectedImageId
      thumbnailElement.dataset.selectedThumbnail = String(isSelected)
      imageElement.dataset.imageId = item.id
    })
  }, [items, selectedImageId])

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!(event.target instanceof HTMLElement)) return

    const imageId = event.target.closest<HTMLElement>('img[data-image-id]')?.dataset.imageId
    if (!imageId) return

    onImageSelect(imageId)
  }

  return {
    ref: imageListRef,
    onClick: handleClick,
  }
}
